import { capitalizeFirstLetter } from 'src/utils/string';
import DesignFacade from '../../../facade/design/design';
import ShoppingCartView from '../../../ui/top-submenu/contents/shopping-cart/view';

module.exports = _.extend({
  shoppingCartLoadingPromise: null,
  initialize: $.noop,
  itemsInCart: {},

  open: function () {
    this.loadWidget(true)
      .then(_.bind(this.trigger, this, 'open'));
  },

  add: function (item) {
    if (Object.values(this.itemsInCart).find((e) => e === item.id)) return;

    this.loadWidget()
      .then(_.bind(this.trigger, this, 'add', item));

    DesignFacade.once('image.create.resize_external', (elem) => {
      if ($('#' + elem.id).data('external_id') === item.id) this.itemsInCart[elem.id] = item.id;
    });
  },

  onReady: function () {
    this.shoppingCartLoadingPromise || this.loadWidget();
    this.shoppingCartLoadingPromise.resolve();
  },

  onTotal: function (total) {
    this.shoppingCartView.setTotal(total);
  },

  onRemove: function (item) {
    DesignFacade.get().forEach(function (element) {
      const $elem = $('#' + element.id);

      if ($elem.removeClass('layoutBox').data('external_id') === item.id) {
        $elem.removeClass('layoutBox');
        DesignFacade.handle(element.id, 'delete');
      }
    });

    this.trigger('removed', item);
  },

  _getReplaceUrl: function (dataInfo) {
    let replaceUrl;
    let type;

    for (const i in dataInfo) {
      type = dataInfo[i].type;
      replaceUrl = dataInfo[i].data.source;
    }

    return [replaceUrl, type];
  },

  _processBackground: function (element, replaceUrl) {
    if (!replaceUrl) return;

    DesignFacade.set(element.id, { source: replaceUrl });
  },

  _replaceImage: function (element, imageUrl, data) {
    DesignFacade.set(element.id, {
      keep_box_size: true,
      source: {
        smart_load: false,
        preload: true,
        url: imageUrl
      },
      skipHistory: data.skipHistory
    });
  },

  _deleteThenAddImage: function (element, imageUrl, data) {
    DesignFacade.create('image', {
      source: {
        url: imageUrl
      },
      imported: true,
      position: element.position,
      size: {
        width: element.size.width,
        height: element.size.height
      },
      skipHistory: data.skipHistory
    });

    DesignFacade.handle(data.thumbId, 'delete', { skipHistory: true });
    DesignFacade.handle(element.id, 'delete', { skipHistory: true });
  },

  _processImage: function (element, replaceUrl, data) {
    const shouldReplace = replaceUrl && element.id !== data.thumbId;
    if (!shouldReplace) return;

    if (!data.thumbId) {
      this._replaceImage(element, replaceUrl, data);
      return;
    }

    this._deleteThenAddImage(element, replaceUrl, data);
  },

  _processSticker: function (element, replaceUrl, data) {
    this._processImage(element, replaceUrl, data);
  },

  onPayment: function (data) {
    const [replaceUrl, type] = this._getReplaceUrl(data.info);
    const elements = data.elementId
      ? DesignFacade.get().filter(element => element.id === data.elementId)
      : DesignFacade.get();

    data.thumbId || this.shoppingCartView.enableMenu();

    this.trigger('paid', data);

    for (const element of elements) {
      const elementType = capitalizeFirstLetter(element.type);
      /**
       * According to the new flow introduced by EDIT-1504
       * we need to replace the original image with the large web image
       * since this upload size would be prioritized by the server
       */
      const imageUrl = replaceUrl.replace('/original/', '/largeweb/');

      this[`_process${elementType}`]?.(element, imageUrl, data);
    }

    type && this.refreshLibrary(type);
  },

  loadWidget: function (shouldShow) {
    if (!this.shoppingCartLoadingPromise) {
      const $view = $('<panel id="shopping-cart-panel">');
      $('#content').append($view);
      $('header > .options > [data-value="project-name"]').css({
        'margin-right': '46px'
      });

      this.shoppingCartView = new ShoppingCartView({ el: $view });
      this.shoppingCartLoadingPromise = $.Deferred();
      DesignFacade.on('delete', _.bind(this.deleteItem, this));
    }

    shouldShow && this.shoppingCartView.show();

    return this.shoppingCartLoadingPromise;
  },

  refreshLibrary: function (type) {
    const tab = INKIVE.Tabs[type.toLowerCase() + 's'];
    if (!tab) return;

    tab.canUseLibrary = true;
    tab.initLibraryView({
      refresh: true
    });
  },

  reset: function () {
    const elements = INKIVE.DesignFacade.get();
    for (let i = 0; i < elements.length; i++) {
      $('#' + elements[i].id).data('external_source', null).data('external_id', null);
    }
  },

  deleteItem: function (id) {
    this.itemsInCart[id] && INKIVE.EditorFacade.trigger('shopping_cart.remove', this.itemsInCart[id]);
    this.itemsInCart[id] = null;
  }
}, Backbone.Events);
